module.exports = __webpack_public_path__ + "img/train-2.d75ac569.jpg";